/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
/* eslint react/prop-types: 0 */
import React from 'react';
import { SeveritySourceEnum } from '../types';
var SeverityScoreDisplay = function SeverityScoreDisplay(_a) {
    var severityScore = _a.severityScore;
    var source = severityScore.source ? SeveritySourceEnum[severityScore.source] : null;
    var severity = severityScore.score.toFixed(1);
    var withSourceLabel = React.createElement(React.Fragment, null,
        React.createElement("dt", null, source + ':'),
        React.createElement("dd", null, severity));
    return (React.createElement("div", null, source ? withSourceLabel : severity));
};
export default SeverityScoreDisplay;
//# sourceMappingURL=SeverityScoreDisplay.js.map